/**
 * @ngdoc directive
 * @name directiveVideoControls
 * @restrict A
 *
 * @description
 * Directive for videoControls block
 *
 * @element ANY
 */
export default function () {
    return {
        restrict: 'A',
        controller: 'videoControlsCtrl',
        scope: true,
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/videoControls.js